const brightRed300Color = '#DF1821';

export default brightRed300Color;
